import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, firstValueFrom } from "rxjs";
import { LockStatusResponseDto } from "src/app/share/interface/password.interface";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class AccountLockService {
  private readonly apiUrl = `${environment.url}/api`;

  constructor(private http: HttpClient) {}

  // Check lock status
  async getLockStatusByEmail(email: string): Promise<LockStatusResponseDto> {
    return await firstValueFrom(
      this.http.get<LockStatusResponseDto>(
        `${this.apiUrl}/accountlocks/GetLockStatus?email=${email}`
      )
    );
  }

  // Add a temporary lock
  addTempLock(email: string, lockDuration: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/accountlocks/AddTempLock`, {
      email,
      lockDuration
    });
  }
}
